var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal-default',{ref:"thisModal",attrs:{"title":_vm.$t('save'),"oncancel":_vm.discardChanges,"onsave":_vm.doSave}},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._v("\n          "+_vm._s(_vm.$t('you_have_made_chages_save_question'))+"\n        ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c258e14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procedure/procedure-save.vue
// module id = 1292
// module chunks = 0